import React, { Component } from 'react';

class ModamilyAppSeparator extends Component {
  render() {
    return (
        <p className="whiteText separator">|</p>
    );
  }
}
export default ModamilyAppSeparator;